import { Box, Stack, Typography, Button, Theme, SxProps } from '@mui/material';
// use plain anchor for external links
import { CardEvent } from 'types/header';

export const PromoCard = ({
  cardEvent,
  sx,
}: {
  cardEvent: CardEvent;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${cardEvent.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100%',
        width: '100%',
        borderRadius: 2,
        minHeight: 240,
        ...sx,
      }}
    >
      <Stack
        sx={{
          height: '100%',
          justifyContent: 'flex-end',
          p: 3,
        }}
      >
        <Typography variant="body1" color={'white'}>
          {cardEvent.title}
        </Typography>
        <Button
          variant="text"
          component="a"
          href={cardEvent.path || '#'}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            alignSelf: 'flex-start',
            color: 'white',
            p: 0,
            textTransform: 'none',
          }}
        >
          {cardEvent.description}
        </Button>
      </Stack>
    </Box>
  );
};
